import type { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';

export const ShipperNavigationBar: FC = () => {
  const { shipperUuid } = useParams<{ shipperUuid: string }>();
  return (
    <Tabs>
      <Link to={`/dashboard/shippers/${shipperUuid}/documents/from`}>
        From Shipper
      </Link>
      <Link to={`/dashboard/shippers/${shipperUuid}/documents/to`}>
        To Shipper
      </Link>
    </Tabs>
  );
};
